// Read every minute, never from the socket: a Kite session ends at 6 AM or on any
// other Kite login, with no event to hear. A failed check is silent by design.
import { API_PATHS, type BrokerStatus, brokerStatusSchema } from '@alphadesk/web/contract.ts';
import { useFreshRead } from './reads.ts';

export interface BrokerState {
  /** Null until the first answer arrives; a check that fails keeps the last answer. */
  status: BrokerStatus | null;
  checking: boolean;
  refresh: () => void;
}

export function useBroker(ask: boolean): BrokerState {
  const { answer, checking, refresh } = useFreshRead<BrokerStatus | null>(
    ask,
    API_PATHS.broker,
    brokerStatusSchema,
    null,
    { keepOnFail: true },
  );
  return { status: answer, checking, refresh };
}
